import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from 'react-redux';
import App from "./components/App"
import { store } from './redux/store'
const entry = document.getElementById('magazineEntry');
const categoryPage = entry.getAttribute('data-category-page');

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App categoryPage={categoryPage} />
        </Provider>
    </React.StrictMode>,
    entry
)